import { render, staticRenderFns } from "./GroupMembersTable.vue?vue&type=template&id=35fb81d8&scoped=true&"
import script from "./GroupMembersTable.vue?vue&type=script&lang=js&"
export * from "./GroupMembersTable.vue?vue&type=script&lang=js&"
import style0 from "./GroupMembersTable.vue?vue&type=style&index=0&id=35fb81d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fb81d8",
  null
  
)

export default component.exports